import { OrderType } from '../../providers/request/order-type.enum';
import { SearchRequest } from '../../providers/request/search-request.model';
import { JgInspType } from './jg-insp-type.enum';
export class JgInspSolutionSearchRequest extends SearchRequest {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  organizationId?: number;
  jgInspType?: JgInspType;
  name?: string;
  fileId?: string;
  fileSn?: string;
  fileName?: string;
  fileMd5?: string;
  uploadTime?: number;
  comment?: string;
  jgSectionIdOrder?: OrderType;
}
